export default "/kiban/_next/static/images/couponBallon-7a9b981a3de40f4e285a185b24745457.png";